import React from 'react';
import Header from '../modules/header';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import btnarow from '../assets/images/icons/back-arrow.png';
import quotevector from '../assets/images/Get_a_quote_now/quote-vector.svg';
import btnarow2 from '../assets/images/icons/button-arrow.svg';
import {Link} from "react-router-dom";
import axios from 'axios';
import { useAlert } from 'react-alert'
import toast from 'toasted-notes' 
import 'toasted-notes/src/styles.css';

class Getquote extends React.Component {
  constructor(props) {
    super(props);
    if(!sessionStorage.getItem('access_token')) {
      sessionStorage.setItem('return-url', window.location.pathname);
      toast.notify('You need to sign in before submitting a quote.');
      this.props.history.push('/signin');
    }
    else {
      var user = JSON.parse(sessionStorage.getItem('user'));
    }

    this.state = {
      yacht: {},
      current_rate: {},
      user: user,
      full_name: user ? user.name : '',
      email: user ? user.email : '',
      approximate_budget: '',
      mobile_number: '',
      preferred_destination: '',
      checkin: new Date(),
      checkout: new Date(),
      notes: '',
      dates_flexible: false,
      error: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeFullName = this.handleChangeFullName.bind(this);
    this.handleChangeMobileNumber = this.handleChangeMobileNumber.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeApproximateBudget = this.handleChangeApproximateBudget.bind(this);
    this.handleChangePreferredDestination = this.handleChangePreferredDestination.bind(this);
    this.handleChangeCheckIn = this.handleChangeCheckIn.bind(this);
    this.handleChangeCheckOut = this.handleChangeCheckOut.bind(this);
    this.handleChangeNotes = this.handleChangeNotes.bind(this);
    this.handleChangeDatesFlexible = this.handleChangeDatesFlexible.bind(this);
  }

  handleChangeFullName(event) {
    this.setState({full_name: event.target.value});
  }

  handleChangeEmail(event) {
    this.setState({email: event.target.value});
  }

  handleChangeMobileNumber(event) {
    this.setState({mobile_number: event.target.value});
  }

  handleChangeApproximateBudget(event) {
    this.setState({approximate_budget: event.target.value});
  }

  handleChangePreferredDestination(event) {
    this.setState({preferred_destination: event.target.value});
  }

  handleChangeCheckIn(date) {
    this.setState({checkin: date, checkout: date});
  }

  handleChangeCheckOut(date) {
    this.setState({checkout: date});
  }

  handleChangeNotes(event) {
    this.setState({notes: event.target.value});
  }

  handleChangeDatesFlexible(event) {
    this.setState({dates_flexible: event.target.checked});
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    const yacht_id = this.props.match.params.id;
    axios.get(`${process.env.REACT_APP_API_URL}/yachts/${yacht_id}.json`)
      .then((response) => {
        this.setState({ 
            yacht: response.data.yacht,
            current_rate: response.data.current_rate
        });
        if(response.data.yacht.category === "sale") {
            this.props.history.push("/yacht/"+response.data.yacht.id);
        }
        window.scrollTo(0, 0)
      })
      .catch();
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = { 
                  full_name: this.state.full_name,
                  email: this.state.email,
                  mobile_number: this.state.mobile_number,
                  estimated_budget: this.state.approximate_budget,
                  preferred_destination: this.state.preferred_destination,
                  check_in_date: this.state.checkin,
                  check_out_date: this.state.checkout,
                  comments: this.state.notes,
                  dates_flexible: this.state.dates_flexible,
                  customer_id: this.state.user.id,
                  yacht_id: this.state.yacht.id
                 };

    axios.post(`${process.env.REACT_APP_API_URL}/yachts/${this.state.yacht.id}/send_inquiry.json`, data)
      .then((response) => {
        const data = response.data;
        if(data.status === true) {
          toast.notify('Enquiry Submitted Successfully');
          this.props.history.push('/');
        }
        else {
          this.setState({ error: "There is some issue in sending inquiry. Please contact later." });
        }
      })
      .catch();
  }

  render() {
    const yacht = this.state.yacht;
    const current_rate = this.state.current_rate;

    return (
      <div className="open_menudiv">
        <Header></Header>
        {/* Main Hero Image section  */}
        <section
          id="date-quote-section"
          className="section fix date-quote-section"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 no-padding">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 ">
                    <div className="date-from-to">
                      <p className="year-month">{new Date().toLocaleString('default', { month: 'long' })} {new Date().getFullYear()}</p>
                      <p className="date-range">{current_rate.week_start}th - {current_rate.week_end}th</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="price-from-div">
                      <p className="price-from">From</p>
                      <p className="total-price">
                        €{ yacht.charter_price } <span>p/week</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="back-btn"></div>
                  </div>
                  <div className="col-lg-6 col-md-6 no-padding">
                    <div className="back-btn2">
                      <button
                        className="btn btn-secondary back-btn-link"
                        id="quote-back"
                      >
                        <Link to={"/yacht/" + yacht.id} className="back_quote">
                          <img src={btnarow} className="img-responsive" alt="button arrow" />
                          Back
                        </Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="quote" className="section fix quote-box">
          <div className="container">
            <div className="row">
              <div className="quote-form">
                <div className="form-vector-img">
                  <img src={quotevector} className="img-responsive" alt="quotevector" />
                </div>
                <div className="heading">
                  <h1>Get a Quote Now</h1>
                  <p>With more details comes a better quote</p>
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <div className="form-group margin-right">
                      <label htmlFor="">Full Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        id=""
                        placeholder="What's your full name?"
                        value={this.state.full_name}
                        onChange={this.handleChangeFullName}
                        readonly="true"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="">Email:</label>
                      <input
                        type="email"
                        className="form-control"
                        id=""
                        placeholder="Your@email.com"
                        value={this.state.email}
                        onChange={this.handleChangeEmail}
                        readonly="true"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group margin-right">
                      <label htmlFor="">Approximate budget:</label>
                      <input
                        type="number"
                        className="form-control"
                        id=""
                        placeholder="Enter Approximate Budget"
                        value={this.state.approximate_budget}
                        onChange={this.handleChangeApproximateBudget}
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="">Mobile Phone:</label>
                      <input
                        type="tel"
                        className="form-control"
                        id=""
                        placeholder="Enter your mobile phone with country code"
                        value={this.state.mobile_number}
                        onChange={this.handleChangeMobileNumber}
                        required
                      />
                    </div>
                    {/* <div className="form-group state-dd">
                      <label htmlFor="inputState"></label>
                      <select id="inputState" className="form-control">
                        <option selected>uk</option>
                        <option>...</option>
                      </select>
                    </div> */}
                  </div>
                  <div className="form-row" id="destiPref">
                    <div className="form-group margin-right" id="formprefdedti">
                      <label htmlFor="">preffered destination:</label>
                      <input
                        type="text"
                        className="form-control"
                        id=""
                        placeholder="Enter preferred destination"
                        value={this.state.preferred_destination}
                        onChange={this.handleChangePreferredDestination}
                        required
                      />
                    </div>
                    <div className="form-group checkin">
                      <label htmlFor="">check in:</label>
                      <DatePicker selected={this.state.checkin} onChange={this.handleChangeCheckIn}/> 
                      
                    </div>
                    <div className="form-group checkout">
                      <label htmlFor="">check out:</label>
                      <DatePicker selected={this.state.checkout} onChange={this.handleChangeCheckOut}/>
                    </div>
                    <div className="form-check date-checkbox">
                      <label className="container2">
                        I'm flexible with the dates
                        <input type="checkbox" 
                          checked={this.state.dates_flexible}
                          onChange={this.handleChangeDatesFlexible}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div className="form-row textarea-row">
                    <div className="form-group">
                      <label htmlFor="">Any notes, or request:</label>
                      <textarea
                        className="form-control"
                        id=""
                        placeholder="Add your requests or notes"
                        value={this.state.notes}
                        onChange={this.handleChangeNotes}
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary btn-theme quote-now-btn"
                      >
                        GET A QUOTE NOW
                        <img
                          src={btnarow2}
                          className="img-responsive"
                          alt="arrow"
                        />
                      </button>
                    </div>
                    <div className="form-group" id="subscrib">
                      <label className="container2 lbl2">
                        Let me know about your special offers
                        <input type="checkbox" defaultChecked />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default Getquote;
